import { supplementalFacilityAnswers } from './state-supplemental-answers.ts';
import type { TierIIStateReporting } from '../../tri-shared/types/tierii-state-fields.ts';

export function stateFacilityIdGet(reporting: TierIIStateReporting, state: string): string {
  const value = supplementalFacilityAnswers(reporting, state).stateFacilityId;
  return value?.trim() ?? '';
}

export function stateFacilityIdRequired(state: string): boolean {
  // EPA's Utah reporting instructions and Tier2 Submit 2025 Rev 1: UT plus six digits.
  // https://www.epa.gov/epcra/state-tier-ii-reporting-requirements-and-procedures#utah
  return state === 'UT';
}

export function stateFacilityIdIssue(reporting: TierIIStateReporting, state: string): string | null {
  if (!stateFacilityIdRequired(state)) return null;
  const value = stateFacilityIdGet(reporting, state);
  if (!value) return 'A Utah State ID is required.';
  if (!/^UT[0-9]{6}$/.test(value)) return 'Utah State ID must be UT followed by six digits (for example, UT001234).';
  return null;
}
